/* ============================================================================
   KOTT Lab — Story Approach. Scroll-driven flow: a glow travels down the
   connector from the first node to the last as the section scrolls, lighting
   each node as it passes. When it reaches the final step it fades and a small
   confetti burst celebrates the finish. Static (all nodes lit) under
   prefers-reduced-motion.
   ============================================================================ */
(function () {
  const isReduced = () => (window.kottReduceMotion ? window.kottReduceMotion() : matchMedia('(prefers-reduced-motion: reduce)').matches);
  const COLORS = ['#576FF6', '#00A47C', '#FF6F3C', '#FFC24B', '#0E0E14'];

  function confetti(node) {
    const sec = node.closest('.ksa');
    if (!sec) return;
    const sr = sec.getBoundingClientRect(), nr = node.getBoundingClientRect();
    const cx = nr.left + nr.width / 2 - sr.left, cy = nr.top + nr.height / 2 - sr.top;
    const wrap = document.createElement('div');
    wrap.style.cssText = 'position:absolute;left:0;top:0;z-index:6;pointer-events:none;';
    sec.appendChild(wrap);
    for (let i = 0; i < 28; i++) {
      const part = document.createElement('i');
      const c = COLORS[i % COLORS.length], sz = 6 + Math.random() * 6;
      part.style.cssText = 'position:absolute;left:' + cx + 'px;top:' + cy + 'px;width:' + sz + 'px;height:' + (sz * 0.62) + 'px;background:' + c + ';border-radius:2px;will-change:transform,opacity;';
      wrap.appendChild(part);
      // small radial burst from the end point, then a gentle gravity fall
      const ang = Math.random() * Math.PI * 2;
      const dist = 36 + Math.random() * 90;
      const dx = Math.cos(ang) * dist;
      const dy = Math.sin(ang) * dist;
      const rot = Math.random() * 720 - 360;
      part.animate([
        { transform: 'translate(0,0) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) rotate(' + rot / 2 + 'deg)', opacity: 1, offset: 0.4 },
        { transform: 'translate(' + (dx * 1.1) + 'px,' + (dy + 150) + 'px) rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 1100 + Math.random() * 500, easing: 'cubic-bezier(.2,.7,.3,1)' });
    }
    setTimeout(function () { wrap.remove(); }, 1900);
  }

  const controllers = [];

  document.querySelectorAll('.ksa').forEach(function (sec) {
    const list = sec.querySelector('.ksa__list');
    const flow = sec.querySelector('.ksa__flow');
    const nodes = [].slice.call(sec.querySelectorAll('.ksa__node'));
    if (!list || !flow || !nodes.length) return;

    let raf = 0, done = false;
    function applyStatic() {
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      flow.style.display = 'none';
      flow.style.opacity = '';
      nodes.forEach((n) => n.classList.add('is-on'));
    }
    controllers.push({ applyStatic: applyStatic });

    if (isReduced()) { applyStatic(); return; }

    function update() {
      raf = 0;
      if (isReduced()) { applyStatic(); return; }   // motion turned off mid-scroll
      const r = list.getBoundingClientRect();
      const line = innerHeight * 0.55;
      let p = (line - r.top) / Math.max(1, r.height);
      p = Math.min(1, Math.max(0, p));
      const centers = nodes.map((n) => { const nr = n.getBoundingClientRect(); return nr.top + nr.height / 2 - r.top; });
      const first = centers[0], last = centers[centers.length - 1];
      const glowY = first + p * (last - first);           // travels first -> last, clamped
      flow.style.top = glowY.toFixed(1) + 'px';
      nodes.forEach((n, i) => n.classList.toggle('is-on', centers[i] <= glowY + 6));

      if (p > 0.985) {
        flow.style.opacity = '0';
        if (!done) { done = true; confetti(nodes[nodes.length - 1]); }
      } else {
        flow.style.opacity = '1';
        if (p < 0.9) done = false;                        // re-arm when scrolled back up
      }
    }
    function onScroll() { if (!raf) raf = requestAnimationFrame(update); }
    addEventListener('scroll', onScroll, { passive: true });
    addEventListener('resize', onScroll, { passive: true });
    update();
  });

  // Live response to the accessibility "stop animations" toggle: snap to the
  // static (all-lit) state when motion is turned off; re-enabling reloads so
  // the scroll-driven glow re-initialises cleanly. Single active handler so
  // repeated shopify:section:load re-inits don't stack listeners.
  function onReduceChange(e) {
    if (e.detail && e.detail.reduced) controllers.forEach((c) => c.applyStatic());
    else location.reload();
  }
  if (window.__ksaReduceHandler) removeEventListener('kott:reduce-motion-change', window.__ksaReduceHandler);
  window.__ksaReduceHandler = onReduceChange;
  addEventListener('kott:reduce-motion-change', onReduceChange);
})();
